import { useState } from "react";
import { IonHeader, IonTitle, IonToolbar } from "@ionic/react";
import { Loader, Segment, Segments } from "components";
import { useFeatureFlags } from "swing-components";

import { FilterBar } from "~components/Organisms/IndexFilters";
import { initialLocalStorageFilterValues } from "~components/Organisms/IndexFilters/types";
import { translate, useLocalStorage } from "~utils";

import { SegmentName, SegmentNameUnion, useRequestIndexFilters, useRequests } from "./hooks";
import { RequestCount } from "./RequestCount";
import { RequestIndex } from "./RequestIndex";
import { getNoRequestsHeader } from "./utils";

const INITIAL_ACTIVE_TAB = SegmentName.Completed;

export function PastRequestsPage() {
  const [activeTab, setActiveTab] = useState<SegmentNameUnion>(INITIAL_ACTIVE_TAB);
  const { flags } = useFeatureFlags();
  const showFilters = Boolean(flags.adminFiltersFe ?? false);

  const { data, isError } = useRequests({
    showHistory: true,
    filterSegment: activeTab,
    getUnfilteredData: showFilters,
  });

  const [ls, setLs] = useLocalStorage(
    "swing-schools:filters:past",
    initialLocalStorageFilterValues,
  );

  const filteredRequests = useRequestIndexFilters(ls, data?.requests);

  if (!data) return <Loader />;

  const pastRequestsSegments: Segments = [
    {
      value: INITIAL_ACTIVE_TAB,
      label: translate("LABEL_PAST_COMPLETED_REQUEST_INDEX_TAB"),
      count: data.counts.past[SegmentName.Completed],
    },
    {
      value: SegmentName.Canceled,
      label: translate("LABEL_PAST_CANCELED_REQUEST_INDEX_TAB"),
      count: data.counts.past[SegmentName.Canceled],
    },
    {
      value: SegmentName.Unfilled,
      label: translate("LABEL_PAST_UNFILLED_REQUEST_INDEX_TAB"),
      count: data.counts.past[SegmentName.Unfilled],
    },
  ];

  const noRequestHeaderString = getNoRequestsHeader(activeTab, "past-requests");

  return (
    <>
      <IonHeader collapse="condense">
        <IonToolbar>
          <IonTitle size="large">{translate("ROUTE_TABLE_PAST_REQUESTS")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      {showFilters ? (
        <>
          <FilterBar page="past" ls={ls} setLs={setLs}></FilterBar>
          <RequestCount page="past" count={filteredRequests.length} />
        </>
      ) : (
        <Segment
          segments={pastRequestsSegments}
          initialValue={activeTab}
          onSegmentChange={setActiveTab}
        />
      )}
      <RequestIndex
        requestType="past-requests"
        requests={showFilters ? filteredRequests : data?.requests}
        noRequestHeaderString={noRequestHeaderString}
        isError={isError}
      />
    </>
  );
}
